import { NETWORK_NAME_PER_CHAIN_ID, SUPPORTED_CHAIN_IDS } from '@/constants/chain';

import { ChainAvatar } from '@/ui/Avatars/ChainAvatar';

import { StyledH2, StyledParagraph, StyledPrimaryCell } from '../utils';

export const SupportedChainsSection = () => (
  <StyledPrimaryCell className="bg-token-gray-100 desktop:pl-15 desktop:pr-15 flex-col items-center justify-center bg-gradient-to-br bg-[url('/images/crosschain/ring-lines-md.svg')] from-[rgba(252,252,253,0.10)] from-[28.82%] via-[#FCFCFD] via-[80.48%] bg-[center_bottom] bg-no-repeat pr-11 pl-11">
    <StyledH2>Across {SUPPORTED_CHAIN_IDS.length} chains</StyledH2>
    <StyledParagraph className="text-center">
      Matcha is available on all your favorite chains.
    </StyledParagraph>
    <ul className="flex pt-7.5 pb-11 max-w-[308px] gap-3 items-center justify-center flex-wrap">
      {SUPPORTED_CHAIN_IDS.map((chainId: number) => (
        <li
          className="before:bg-token-gray-200 before:opacity-70 before:border-token-alphalight-300 relative flex items-center justify-center p-3 before:absolute before:inset-0 before:top-0 before:right-0 before:bottom-0 before:left-0 before:-m-[1px] before:rounded-2xl before:border-[1px] before:content-['']"
          key={chainId}
        >
          <ChainAvatar
            chainId={chainId}
            alt={`${NETWORK_NAME_PER_CHAIN_ID[chainId]} icon`}
            size={44}
          />
        </li>
      ))}
    </ul>
  </StyledPrimaryCell>
);
